// Constants and dropdown options for Mobile Bond Insurance Analysis

// Property Types
export const propertyTypeOptions = [
  { key: 'APARTMENT', value: 'APARTAMENTO', text: 'Apartamento' },
  { key: 'STANDARD_HOUSE', value: 'CASA_PADRAO', text: 'Casa' },
  { key: 'KITNET', value: 'KITNET', text: 'Kitnet' },
  { key: 'LOFT', value: 'SOBRADO', text: 'Sobrado' },
  { key: 'ROOF', value: 'COBERTURA', text: 'Cobertura' },
  { key: 'COMMERCIAL_ROOM', value: 'SALA_COMERCIAL', text: 'Sala Comercial' },
  { key: 'COMMERCIAL_STORE', value: 'LOJA_COMERCIAL', text: 'Loja Comercial' },
  { key: 'COMMERCIAL_HOUSE', value: 'CASA_COMERCIAL', text: 'Casa Comercial' },
  { key: 'GROUND', value: 'TERRENO', text: 'Terreno' },
];

// Reasons for Natural Person - Residential
export const naturalResidentialReasons = [
  { key: 1, value: 'Independência', text: 'Independência' },
  { key: 2, value: 'Casamento', text: 'Casamento' },
  { key: 3, value: 'Separação', text: 'Separação' },
  { key: 4, value: 'Próximo ao trabalho', text: 'Próximo ao trabalho' },
  { key: 5, value: 'Próximo a instituições de ensino', text: 'Próximo a instituições de ensino' },
  { key: 6, value: 'Imóvel próximo de familiares', text: 'Imóvel próximo de familiares' },
  { key: 7, value: 'Transferência de empresa', text: 'Transferência de empresa' },
  { key: 8, value: 'Redução de custo', text: 'Redução de custo' },
  { key: 9, value: 'Venda de imóvel próprio', text: 'Venda de imóvel próprio' },
  { key: 10, value: 'Renovação com aumento de valores', text: 'Renovação com aumento de valores' },
  { key: 11, value: 'Troca de garantia da atual locação', text: 'Troca de garantia' },
];

// Reasons for Natural Person - Commercial
export const naturalCommercialReasons = [
  { key: 1, value: 'Abertura de Filial', text: 'Abertura de Filial' },
  { key: 2, value: 'Locação para moradia', text: 'Locação para moradia' },
  { key: 3, value: 'Troca de garantia', text: 'Troca de garantia' },
  { key: 4, value: 'Troca de local de sede', text: 'Troca de local de sede' },
];

// Reasons for Legal Person
export const legalCommercialReasons = [
  { key: 1, value: 'Abertura de Filial', text: 'Abertura de Filial' },
  { key: 2, value: 'Locação para moradia', text: 'Locação para moradia' },
  { key: 3, value: 'Troca de garantia', text: 'Troca de garantia' },
  { key: 4, value: 'Troca de local de sede', text: 'Troca de local de sede' },
];

// Marital Status
export const maritalStatusOptions = [
  { key: 'SOLTEIRO', value: 'SOLTEIRO', text: 'Solteiro(a)' },
  { key: 'CASADO', value: 'CASADO', text: 'Casado(a)' },
  { key: 'DIVORCIADO', value: 'DIVORCIADO', text: 'Divorciado(a)' },
  { key: 'VIUVO', value: 'VIUVO', text: 'Viúvo(a)' },
  { key: 'SEPARADO', value: 'SEPARADO', text: 'Separado(a)' },
  { key: 'UNIAO_ESTAVEL', value: 'UNIAO_ESTAVEL', text: 'União Estável' },
];

// Employment Relationship
export const employmentRelationshipOptions = [
  { key: 'PRIVATE_SERVANT', value: 'PRIVATE_SERVANT', text: 'CLT' },
  { key: 'CIVIL_SERVANT', value: 'CIVIL_SERVANT', text: 'Funcionário Público' },
  { key: 'ENTREPRENEUR', value: 'ENTREPRENEUR', text: 'Empresário' },
  { key: 'FREELANCE', value: 'FREELANCE', text: 'Autônomo' },
  { key: 'LIBERAL', value: 'LIBERAL', text: 'Profissional Liberal' },
  { key: 'RETIRED', value: 'RETIRED', text: 'Aposentado' },
  { key: 'STUDENT', value: 'STUDENT', text: 'Estudante' },
  { key: 'RENT_INCOME', value: 'RENT_INCOME', text: 'Renda de Aluguéis' },
];

// Gender Options
export const genderOptions = [
  { key: 'MASCULINO', value: 'MASCULINO', text: 'Masculino' },
  { key: 'FEMININO', value: 'FEMININO', text: 'Feminino' },
];

// Validity Options (in months)
export const validityOptions = [
  { key: 12, value: 12, text: '12 meses' },
  { key: 18, value: 18, text: '18 meses' },
  { key: 24, value: 24, text: '24 meses' },
  { key: 30, value: 30, text: '30 meses' },
  { key: 36, value: 36, text: '36 meses' },
  { key: 48, value: 48, text: '48 meses' },
  { key: 60, value: 60, text: '60 meses' },
];

// UF Options
export const ufOptions = [
  { key: 'AC', value: 'AC', text: 'AC' },
  { key: 'AL', value: 'AL', text: 'AL' },
  { key: 'AP', value: 'AP', text: 'AP' },
  { key: 'AM', value: 'AM', text: 'AM' },
  { key: 'BA', value: 'BA', text: 'BA' },
  { key: 'CE', value: 'CE', text: 'CE' },
  { key: 'DF', value: 'DF', text: 'DF' },
  { key: 'ES', value: 'ES', text: 'ES' },
  { key: 'GO', value: 'GO', text: 'GO' },
  { key: 'MA', value: 'MA', text: 'MA' },
  { key: 'MT', value: 'MT', text: 'MT' },
  { key: 'MS', value: 'MS', text: 'MS' },
  { key: 'MG', value: 'MG', text: 'MG' },
  { key: 'PA', value: 'PA', text: 'PA' },
  { key: 'PB', value: 'PB', text: 'PB' },
  { key: 'PR', value: 'PR', text: 'PR' },
  { key: 'PE', value: 'PE', text: 'PE' },
  { key: 'PI', value: 'PI', text: 'PI' },
  { key: 'RJ', value: 'RJ', text: 'RJ' },
  { key: 'RN', value: 'RN', text: 'RN' },
  { key: 'RS', value: 'RS', text: 'RS' },
  { key: 'RO', value: 'RO', text: 'RO' },
  { key: 'RR', value: 'RR', text: 'RR' },
  { key: 'SC', value: 'SC', text: 'SC' },
  { key: 'SP', value: 'SP', text: 'SP' },
  { key: 'SE', value: 'SE', text: 'SE' },
  { key: 'TO', value: 'TO', text: 'TO' },
];

// Helper to get reasons based on tenant type and purpose
export const getReasonOptions = (tenantType: 'NATURAL' | 'LEGAL', purpose: 'RESIDENTIAL' | 'COMMERCIAL') => {
  if (tenantType === 'LEGAL') {
    return legalCommercialReasons;
  }
  return purpose === 'RESIDENTIAL' ? naturalResidentialReasons : naturalCommercialReasons;
};

// Politically Exposed Person
export const politicallyExposedPersonOptions = [
  { key: 'NO', value: 'NO', text: 'Não' },
  { key: 'YES', value: 'YES', text: 'Sim' },
  { key: 'CLOSE_TO', value: 'CLOSE_TO', text: 'Próximo a PEP' },
];

// Nationality (most common options)
export const nationalityOptions = [
  { key: 'Brasileira', value: 'Brasileira', text: 'Brasileira' },
  { key: 'Americana', value: 'Americana', text: 'Americana' },
  { key: 'Argentina', value: 'Argentina', text: 'Argentina' },
  { key: 'Boliviana', value: 'Boliviana', text: 'Boliviana' },
  { key: 'Chilena', value: 'Chilena', text: 'Chilena' },
  { key: 'Colombiana', value: 'Colombiana', text: 'Colombiana' },
  { key: 'Espanhola', value: 'Espanhola', text: 'Espanhola' },
  { key: 'Francesa', value: 'Francesa', text: 'Francesa' },
  { key: 'Italiana', value: 'Italiana', text: 'Italiana' },
  { key: 'Japonesa', value: 'Japonesa', text: 'Japonesa' },
  { key: 'Paraguaia', value: 'Paraguaia', text: 'Paraguaia' },
  { key: 'Peruana', value: 'Peruana', text: 'Peruana' },
  { key: 'Portuguesa', value: 'Portuguesa', text: 'Portuguesa' },
  { key: 'Uruguaia', value: 'Uruguaia', text: 'Uruguaia' },
  { key: 'Venezuelana', value: 'Venezuelana', text: 'Venezuelana' },
  { key: 'Outra', value: 'Outra', text: 'Outra' },
];
